import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  searchInput: {
    borderRadius: 4,
    width: '100%',
    height: 50,
    justifyContent: 'center',
    background: '#fff',
    [theme.breakpoints.down('md')]: {
      height: 48,
      fontSize: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      height: 44,
      fontSize: '13px',
    },
    [theme.breakpoints.down('xs')]: {
      height: 40,
      fontSize: '12px',
    },
    '& .MuiInput-underline': {
      '&:before': {
        display: 'none',
      },
      padding: `0 ${theme.spacing(1.5)}px 1px ${theme.spacing(1.5)}px`,
      [theme.breakpoints.down('sm')]: {
        padding: `0 ${theme.spacing(1)}px 1px ${theme.spacing(1)}px`,
      },
      '&:after': {
        display: 'none',
      },
    },
    '& .MuiInputBase-input': {
      padding: `0 ${theme.spacing(1)}px 1px ${theme.spacing(1)}px`,
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
        padding: `0 ${theme.spacing(0.8)}px 1px ${theme.spacing(0.8)}px`,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
        padding: `0 ${theme.spacing(0.6)}px 1px ${theme.spacing(0.6)}px`,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
        padding: `0 ${theme.spacing(0.5)}px 1px ${theme.spacing(0.5)}px`,
      },
      '&::-webkit-input-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
        [theme.breakpoints.down('sm')]: {
          fontSize: 13,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 12,
        },
      },
      '&::-moz-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
        [theme.breakpoints.down('sm')]: {
          fontSize: 13,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 12,
        },
      },
      '&:-moz-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
        [theme.breakpoints.down('sm')]: {
          fontSize: 13,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 12,
        },
      },
      '&:-ms-input-placeholder': {
        color: theme.palette.text.primary,
        fontSize: 14,
        [theme.breakpoints.down('sm')]: {
          fontSize: 13,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: 12,
        },
      },
    },
  },
  centerHeadBox: {
    flexGrow: 1,
    // margin: `0 ${theme.spacing(2)}px`,
    [theme.breakpoints.down('md')]: {
      margin: `0 ${theme.spacing(1.5)}px`,
    },
    [theme.breakpoints.down('sm')]: {
      margin: `0 ${theme.spacing(1)}px`,
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      margin: 0,
      width: '100%',
    },
  },
}));
